import React from 'react';
import { Button, Form, ModalBody, ModalFooter } from 'reactstrap';
import { AlertTriangle } from "react-feather";

export const DeleteSpecialty = ({ toggle, loading, name, saveDelete }) => {
    return (
        <Form role="form" onSubmit={saveDelete}>
            <ModalBody className="pb-0">

                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    marginBottom: "15px"
                }}>
                    <div style={{
                        backgroundColor: "#ffe6e6",
                        borderRadius: "50%",
                        width: "80px",
                        height: "48px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <AlertTriangle size={28} color="#c92a2a" />
                    </div>

                    <div>
                        <p
                            className="mb-0"
                            style={{
                                fontSize: "13px",
                                color: "#0d3b59"
                            }}
                        >
                            Esta acción no se puede deshacer. ¿Estás seguro de eliminar la especialidad?
                        </p>
                    </div>
                </div>

                <div style={{
                    background: "#f8fbff",
                    padding: "12px 14px",
                    borderRadius: "8px",
                    border: "1px solid #d7e7f5"
                }}>
                    <span style={{ fontWeight: 500, color: "#0d3b59" }}>
                        {name}
                    </span>
                </div>

                <br />
            </ModalBody>

            <ModalFooter className="pt-0">

                <Button
                    size="sm"
                    color="danger"
                    type="submit"
                    style={{
                        padding: "8px 14px",
                        fontWeight: 600,
                        minWidth: "150px"
                    }}
                    className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                >
                    {loading ? "Eliminando..." : "Sí, eliminar"}
                </Button>

                <Button
                    size="sm"
                    type="button"
                    color="secondary"
                    className="btn-air-light"
                    onClick={toggle}
                >
                    Cancelar
                </Button>

            </ModalFooter>
        </Form>
    )
}
